import { FontWeight } from "lib/styles";
import { Text } from 'styles/themeColors';

const initialColumns = [
  {
    title: 'OFMP Company ID',
    field: 'companyId',
    width: '20%',
    removable: false,
    headerStyle: { color: Text.primary, minWidth: '135px !important', fontWeight: FontWeight.bold },

  },
  {
    title: 'Status',
    field: 'status',
    removable: false,
    headerStyle: { color: Text.primary, minWidth: '135px !important', fontWeight: FontWeight.bold },

  },
  {
    title: 'MDM ID',
    field: 'vendor.vendorCompanyId',
    width: '20%',
    removable: false,
    headerStyle: { color: Text.primary, minWidth: '135px !important', fontWeight: FontWeight.bold },
  },
  {
    title: 'OFMP Company Name',
    field: 'companyName',
    width: '35%',
    headerStyle: { color: Text.primary, minWidth: '135px !important', fontWeight: FontWeight.bold },
  },
  {
    title: 'Company Legal Name',
    field: 'displayName',
    width: '35%',
    headerStyle: { color: Text.primary, minWidth: '135px !important', fontWeight: FontWeight.bold },
  },
  {
    title: 'Contact Type',
    field: 'contactType',
    headerStyle: { color: Text.primary, minWidth: '135px !important', fontWeight: FontWeight.bold },
  },
  {
    title: 'Customer Since',
    field: 'customerSince',
    type: 'date',
    dateSetting: { locale: 'en-US' },
    defaultSort: 'desc',
    headerStyle: { color: Text.primary, minWidth: '135px !important', fontWeight: FontWeight.bold },
  },
  {
    title: 'Country',
    field: 'countryName',
    width: '13%',
    headerStyle: { color: Text.primary, minWidth: '135px !important', fontWeight: FontWeight.bold },
  }
];

export default initialColumns;
